<template>
  <div class="d-flex align-center">
    <div class="ml-5 mr-2 font-weight-bold">
      Type d'intervention :
    </div>
    <checkable-button
      v-for="label in possibleReferences"
      :label="label"
      :value="label | find(references)"
      @input="onChange(label, $event)"
      :key="label"
      class="ma-2 caption"
    />
  </div>
</template>

<script>
import CheckableButton from '@/components/selects/CheckableButton';

export default {
  name: 'InterventionsFilter',
  components: { CheckableButton },
  props: {
    namespace: { type: String, required: true },
  },
  computed: {
    references() {
      const ref = this.$store.getters[`${this.namespace}/attributesObj`]
        .reference;
      return ref ? ref.values : [];
    },
  },
  data: () => ({
    possibleReferences: ['DI', 'DIT', 'Visite', 'Travaux'],
  }),
  filters: {
    find(label, obj) {
      return obj && obj.some((item) => item === label);
    },
  },
  methods: {
    onChange(label, val) {
      let newValues = [...this.references] || [];
      if (val) {
        newValues.push(label);
      } else {
        newValues = newValues.filter((item) => item !== label);
      }
      this.$store.dispatch(`${this.namespace}/setFilterAttribute`, {
        attribute: 'reference',
        values: newValues,
      });
    },
  },
};
</script>
